import React from "react";
import TextField from "@mui/material/TextField";
import { Autocomplete, Box } from "@mui/material";
import countriesData from "constants/countries.json";

export default function CurrencySelector(props) {
  // We use the countries list as the source for currencies to show the mapping
  const options = countriesData;

  return (
    <Autocomplete
      value={options.find(o => o.currency === props.value && (!props.country || o.name === props.country)) || options.find(o => o.currency === props.value) || null}
      options={options}
      autoHighlight
      getOptionLabel={(option) => `${option.currency} - ${option.name}`}
      onChange={(event, newValue) => {
        props.onChange(event, newValue?.currency || "");
      }}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props;
        return (
          <Box key={key} component="li" {...optionProps}>
            {option.currency} - {option.name}
          </Box>
        );
      }}
      renderInput={(params) => <TextField {...params} label="Moneda" variant="outlined" />}
      required={props.required ? true : false}
      disabled={Boolean(props.disabled)}
    />
  );
}
